module.exports = __webpack_public_path__ + "img/comprehensive-overview-active.143195cf.svg";